import { useEffect, useState } from "react";

function getMediaQueryMatches(query: string): boolean {
    if (typeof window === "undefined") return false;

    return window.matchMedia(query).matches;
}

/**
 * Возвращает `true`, если текущий viewport соответствует media query.
 * @param query CSS media query для проверки viewport.
 * @returns Текущее состояние `window.matchMedia`.
 */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => getMediaQueryMatches(query));

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mediaQueryList = window.matchMedia(query);

        const handleChange = (event: MediaQueryListEvent) => {
            setMatches(event.matches);
        };

        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener("change", handleChange);

        return () => {
            mediaQueryList.removeEventListener("change", handleChange);
        };
    }, [query]);

    return matches;
}
